import {React,useEffect} from 'react';
import Breadcrumbs from '../components/Breadcrumbs'
import InnerServices from '../components/InnerServices'
import InnerCards from '../components/InnerCards'
import InnerFaq from '../components/InnerFaq'
import Contact from "../components/Contact"

function ConstructionScanningServices() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div>
        <Breadcrumbs currentTitle={"Construction Laser Scanning"} currentpage={"Construction Scanning Services"} currentcontent={"Captures all details of an existing building or a construction site."} backgroundImage={"assets/img/leo/bg/12.jpg"} />
    <section >
    <div className='container'>
      <div class="section-title">
         <h2>Data-Rich 3D Laser Scanning Services For Construction</h2>
      </div>
      <p style={{textAlign:'justify'}}>
      Construction 3D laser scanning is a technology that uses laser scanners to capture highly accurate and detailed data of a construction site. The laser scanner emits a laser beam that measures distances and captures millions of data points, creating a highly detailed point cloud of the site. The<strong> point cloud data</strong> can then be used to create 3D models, maps, and drawings that provide a highly accurate representation of the site’s existing conditions.
     <br></br><br></br>
      It can be used throughout the construction project lifecycle, from the initial planning stages to the final construction and maintenance phases. Here are some common use cases for construction 3D laser scanning: Site analysis and surveying, Design and planning, Quality control and inspection, Project management, Maintenance and renovation. 
      </p>
    </div>
    </section>


    <InnerServices title="Building Construction With 3D Laser Scanning Solutions" paragraph="" />

    <InnerCards title={"Construction 3D Laser Scanning Process"} paragraph={"The 3D laser scanning process involves several steps to capture highly accurate and detailed data of a site. Here are the typical steps involved in the 3D laser scanning process:"} />

    {/* <InnerFaq /> */}

    <Contact />
    </div>
  )
}

export default ConstructionScanningServices